import { render, staticRenderFns } from "./CenterGiftChannel.vue?vue&type=template&id=59388c64&scoped=true"
import script from "./CenterGiftChannel.vue?vue&type=script&lang=js"
export * from "./CenterGiftChannel.vue?vue&type=script&lang=js"
import style0 from "./CenterGiftChannel.vue?vue&type=style&index=0&id=59388c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59388c64",
  null
  
)

export default component.exports